import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Developed by{" "}
          <a href="http://texolworld.com/" target="_blank"  rel="noreferrer">
            Texol
          </a>{" "}
          2022
        </p>
      </div>
    </div>
  );
};

export default Footer;
